/**
 * Get initials from a name string
 * @param {string} name - Full name
 * @returns {string} Initials (up to 2 characters)
 */
export const getInitials = (name) => {
  if (!name) return "N"
  return name
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
}
